import { NetworkDataType } from '@/common/models/NetworkDataTransfers';
import { getCodeUrl } from '@/common/utils/url';
import { AppDataTransfer_CONTROLLER } from '@toilet-paper-games/core';
import { makeAutoObservable, toJS } from 'mobx';
import { ControllerAppModel } from './ControllerAppModel';
import { ControllerPlayerModelHandler } from './ControllerPlayerModelHandler';
import { GameInfo } from '@/types';

export class ControllerInjectedGameDataHandler {
  playerModelHandler: ControllerPlayerModelHandler;

  // TODO: Determine if this is needed - currently this isn't read, only set
  ready = false;

  hosterReady = false;

  constructor(
    private game: GameInfo,
    private appModel: ControllerAppModel,
    public lobbyGame: boolean,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });

    const user = appModel.user;

    if (!user) {
      throw new Error('User is not set');
    }

    this.playerModelHandler = new ControllerPlayerModelHandler(user);

    this.setupStorage();
  }

  setup() {
    this.ready = false;
    this.hosterReady = false;

    this.playerModelHandler.setupReaction();
    const readyListenerDestroyer = this.setupHosterReadyListener();

    return () => {
      this.playerModelHandler.destroy();
      readyListenerDestroyer();
    };
  }

  setupStorage() {
    this.fetchGameStorage().then((storage) => {
      this.gameStorage = storage;
    });
  }

  get gameStorageKey() {
    return `tpg-controller-game-${this.game.uniqueName}-storage`;
  }

  gameStorage: Record<string, string | undefined> | null = null;

  // This is async for possible change to use firebase later
  async fetchGameStorage(): Promise<Record<string, string | undefined>> {
    const content = localStorage.getItem(this.gameStorageKey);

    if (!content) {
      return {};
    }

    return JSON.parse(content);
  }

  async updateGameStorage(key: string, value: string | undefined) {
    const content = await this.fetchGameStorage();

    content[key] = value;

    localStorage.setItem(this.gameStorageKey, JSON.stringify(content));
    this.gameStorage = content;
  }

  setupHosterReadyListener() {
    return this.appModel.networkHandler.addDataListener((payload) => {
      this.hosterReady = payload.data.ready;
    }, NetworkDataType.GAME_READY_STATUS_HOSTER_H2C);
  }

  get injectedGameData(): AppDataTransfer_CONTROLLER['data'] {
    const uuid = this.appModel.uuid;

    if (!uuid) {
      throw new Error('No connectionId found');
    }

    return {
      connectionId: uuid,
      player: toJS(this.playerModelHandler.playerModel.dto),
      hosterReady: this.hosterReady,
      joinUrl: getCodeUrl(uuid),
      joinCode: uuid,
      devMode: this.appModel.devMode,
      lobbyGame: this.lobbyGame,

      // TODO: add global settings and game settings here
      gameStorage: toJS(this.gameStorage),
      globalSettings: toJS(this.appModel.controllerGlobalSettings),
    };
  }
}
